// No longer animates itself — Layout.jsx already wraps its child routes in a
// single animated motion.div for the page transition. Stacking a second,
// differently-timed animation here (this used to run its own pageVariants at
// a different duration) compounded into a soft, blurry-looking transition
// even after the blur filter itself was removed from pageVariants.
//
// Footer used to live here too, but that made it re-mount/re-animate inside
// the per-route transition and, more importantly, sit inside the same
// flex-1 chain as the page content — meaning a tall page pushed it below the
// fold instead of leaving it pinned. Footer is now rendered once by Layout.jsx
// as a fixed sibling of the scrollable content area, not per-route.
export const TerminalView = ({ children }) => (
  <div className="relative w-full flex-1 flex flex-col min-h-0">
    {children}
  </div>
);